/* eslint-disable no-undef */
export default {
  install(app) {
    if (import.meta.env.MODE === 'production') {
      (function (m, e, t, r, i, k, a) {
        m[i] =
          m[i] ||
          function () {
            (m[i].a = m[i].a || []).push(arguments);
          };
        m[i].l = 1 * new Date();
        for (var j = 0; j < document.scripts.length; j++) {
          if (document.scripts[j].src === r) {
            return;
          }
        }
        (k = e.createElement(t)),
        (a = e.getElementsByTagName(t)[0]),
        (k.async = 1),
        (k.src = r),
        a.parentNode.insertBefore(k, a);
      })(
        window,
        document,
        'script',
        'https://mc.yandex.ru/metrika/tag.js?id=103611837',
        'ym'
      );

      ym(103611837, 'init', {
        ssr: true,
        webvisor: true,
        clickmap: true,
        ecommerce: 'dataLayer',
        accurateTrackBounce: true,
        trackLinks: true
      });

      const noscript = document.createElement('noscript');
      noscript.innerHTML =
        '<div><img src="https://mc.yandex.ru/watch/103611837" style="position:absolute; left:-9999px;" alt="" /></div>';
      document.body.appendChild(noscript);
    }
  }
};
